<template>
  <Loader v-if="loading" />
  <div v-else>
    <BaseFormGroup>
      <BaseFormLabel :for="`${_uid}-contactListUuid`"> Contact List * </BaseFormLabel>

      <BaseFormSelect
        :value="defaultData.contactListUuid"
        :options="options"
        :id="`${_uid}-contactListUuid`"
        @input="setProps"
      />
    </BaseFormGroup>
  </div>
</template>

<script>
import { projectContactListsClient } from '@/api/clients';

export default {
  props: {
    projectUuid: { type: String, required: true },
    defaultData: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      options: [],
    };
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.loading = true;

      try {
        const { data = {} } = await projectContactListsClient.list(this.projectUuid);

        if (data && data.data) {
          this.options = data.data.map(({ id, name }) => ({ label: name, value: id }));
        }
      } catch (error) {
        //
      }

      this.loading = false;
    },

    setProps(contactListUuid) {
      if (!contactListUuid) this.$emit('update-props', null);

      this.$emit('update-props', { contactListUuid });
    },
  },
};
</script>
